/* kiln-filters.js — client-side filtering for kiln collection pages */
(function () {
  'use strict';

  function init() {
    const root = document.querySelector('[data-kc-kiln-filters]');
    if (!root) return;

    // Load the product-id → tags map injected by the snippet
    let tagMap = {};
    const tagJson = document.querySelector('[data-kc-product-tags]');
    if (tagJson) {
      try { tagMap = JSON.parse(tagJson.textContent || '{}'); }
      catch (e) { console.warn('[kiln-filters] could not parse tag map', e); return; }
    }

    // Find product cards. Superstore uses .productitem with data-product-id.
    let products = Array.from(document.querySelectorAll('.productitem[data-product-id], .productitem[data-product-handle], .productgrid--item'));
    if (products.length === 0) {
      products = Array.from(document.querySelectorAll('[class*="productitem"], [class*="product-item"]'));
    }
    if (products.length === 0) {
      console.warn('[kiln-filters] no product cards found');
      return;
    }

    // Tag each product with its tags from the map
    products.forEach((p) => {
      p.setAttribute('data-kc-product', '');
      const id = p.dataset.productId || (p.querySelector('[data-product-id]') || {}).dataset?.productId;
      if (id && tagMap[id]) p._kcTags = tagMap[id];
      else p._kcTags = [];
    });

    const checkboxes = root.querySelectorAll('[data-kc-filter]');
    const summary = root.querySelector('[data-kc-summary]');
    const clearBtn = root.querySelector('[data-kc-clear]');

    function getActive() {
      const byFamily = {};
      checkboxes.forEach((cb) => {
        if (cb.checked) {
          const fam = cb.dataset.family;
          (byFamily[fam] = byFamily[fam] || []).push(cb.value);
        }
      });
      return byFamily;
    }

    function productMatches(p, active) {
      for (const fam in active) {
        const wanted = active[fam];
        if (!wanted.some((t) => p._kcTags.includes(t))) return false;
      }
      return true;
    }

    function applyFilters() {
      const active = getActive();
      let visible = 0;
      products.forEach((p) => {
        const ok = productMatches(p, active);
        p.dataset.kcHidden = ok ? 'false' : 'true';
        if (ok) visible++;
      });

      if (summary) {
        const total = products.length;
        const fams = Object.keys(active);
        summary.textContent = fams.length === 0
          ? 'Showing ' + total + ' ' + (total === 1 ? 'kiln' : 'kilns')
          : 'Showing ' + visible + ' of ' + total + ' kilns';
      }

      if (clearBtn) clearBtn.hidden = (Object.keys(active).length === 0);

      // Forecast counts: how many would still match if THIS box were toggled
      checkboxes.forEach((cb) => {
        const fam = cb.dataset.family;
        const tag = cb.value;
        const hyp = JSON.parse(JSON.stringify(active));
        if (cb.checked) {
          hyp[fam] = (hyp[fam] || []).filter((v) => v !== tag);
          if (hyp[fam].length === 0) delete hyp[fam];
        } else {
          (hyp[fam] = hyp[fam] || []).push(tag);
        }
        let count = 0;
        for (const p of products) if (productMatches(p, hyp)) count++;
        const label = cb.closest('label');
        const countEl = label.querySelector('[data-kc-count]');
        if (countEl) countEl.textContent = count > 0 ? '(' + count + ')' : '';
        if (count === 0 && !cb.checked) {
          label.setAttribute('data-kc-disabled', '');
          cb.disabled = true;
        } else {
          label.removeAttribute('data-kc-disabled');
          cb.disabled = false;
        }
      });

      // URL hash sync
      const params = [];
      for (const fam in active) {
        params.push(fam + '=' + active[fam].map((t) => encodeURIComponent(t.split(':')[1])).join(','));
      }
      const newHash = params.length ? '#kf:' + params.join('&') : '';
      if (window.location.hash !== newHash) {
        history.replaceState(null, '', window.location.pathname + window.location.search + newHash);
      }
    }

    function readHash() {
      const m = window.location.hash.match(/^#kf:(.+)$/);
      if (!m) return;
      m[1].split('&').forEach((p) => {
        const [fam, valStr] = p.split('=');
        if (!fam || !valStr) return;
        valStr.split(',').forEach((v) => {
          const cb = root.querySelector(
            '[data-kc-filter][data-family="' + fam + '"][data-value="' + decodeURIComponent(v) + '"]'
          );
          if (cb) cb.checked = true;
        });
      });
    }

    checkboxes.forEach((cb) => cb.addEventListener('change', applyFilters));
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        checkboxes.forEach((cb) => (cb.checked = false));
        applyFilters();
      });
    }

    readHash();
    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
